import Appointment from '@/components/Appointment/Appointment';
import AppointmentSpecials from '@/components/AppointmentSpecials/AppointmentSpecials';
import InputEmail from '@/components/inputs/InputEmail/InputEmail';
import ParticipantAdministrative from '@/components/ParticipantAdministrative/ParticipantAdministrative';
import SectionTitle from '@/components/SectionTitle/SectionTitle';
import { AppointmentDTO } from '@/models/AppointmentDTO';
import { ActionTypes, GetterTypes } from '@/store-vuex/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { ParticipantDTO } from '@/models/ParticipantDTO';
import { useEquestHome } from '@/config/app.config';
import InputTel from '@/components/inputs/InputTel/InputTel';
import InformationBlock from '../InformationBlock/InformationBlock';
import { McsisConstants } from '@/models/constants/McsisConstants';

@Component({
  components: {
    Appointment,
    InputEmail,
    InputTel,
    ParticipantAdministrative,
    SectionTitle,
    AppointmentSpecials,
    InformationBlock,
},
})
export default class AppointmentRecap extends Vue {
  @Prop(Boolean) public readonly!: boolean;

  private phoneRegex = new RegExp(McsisConstants.PhoneNumberRegex);
  private internationalPhoneRegex = new RegExp(McsisConstants.InternationalPhoneNumberRegex);
  private emailRegex = new RegExp(McsisConstants.EmailRegex);

  protected mounted(): void {
    this.checkValidity();
  }

  private get appointment(): AppointmentDTO {
    return this.$store.getters[GetterTypes.appointment];
  }

  private setAppMobile( mobile: string | null) {
    this.$store.commit(ActionTypes.setAppMobile, mobile);
    this.checkValidity();
  }

  private setAppEmail( email: string | null) {
    this.$store.commit(ActionTypes.setAppEmail, email);
    this.checkValidity();
  }

  private checkValidity(): void {
    const emailValidity = this.appointment.appEmail == null // not required
      || this.appointment.appEmail === McsisConstants.EmptyString
      || this.emailRegex.test(this.appointment.appEmail);

    const mobileValidity = this.appointment.appMobile == null  // required
      || this.appointment.appMobile === McsisConstants.EmptyString
      || this.internationalPhoneRegex.test(this.appointment.appMobile)
      || this.phoneRegex.test(this.appointment.appMobile);

    this.$emit('validityChange', mobileValidity && emailValidity);
  }

  private get isModified(): boolean {
    return this.$store.getters[GetterTypes.isRdvModified];
  }

  private get isEdition(): boolean {
    return this.$store.getters[GetterTypes.hasRdv];
  }

  private get participant(): ParticipantDTO {
    return this.$store.getters[GetterTypes.participant];
  }

  private get hasParticularity(): boolean {
    return this.$store.getters[GetterTypes.useLongAppointment] ||
      this.$store.getters[GetterTypes.useTRMGenderChoice];
  }

  protected get showEquestLink(): boolean {
    return useEquestHome(this.$route.params.screening) && this.readonly;
  }

  private get equestRouteName(): string {
    const equest = process.env.VUE_APP_EQUEST_ROOT;
    const suName = this.$route.params.screening;
    const birthDate = moment(this.participant.birthDate).format(McsisConstants.SwissDateFormat);
    const partId = this.participant.partId;

    return `${equest}/${suName}/at-home/identification?partId=${partId}&birthDate=${birthDate}`;
  }

  private get titleKey(): string  {
    if (this.isModified) {
        return 'page.recap.modificationTitle';
    } else if (this.isEdition) {
        return 'page.recap.editionTitle';
    } else {
        return 'page.recap.insertTitle';
    }
  }
}
